import { Button, Tooltip } from '$components'
import { useUpdatePetInformationForm } from './index'
import { useTenant } from '$features/auth/hooks/use-tenant'
import { SUBSCRIPTION_EXPIRED_MESSAGE } from '$constants/subscription'

export function UpdatePetInformationControls() {
  const { onCancel, isLoading } = useUpdatePetInformationForm()
  const { hasSubscriptionExpired } = useTenant()

  const isButtonDisabled = hasSubscriptionExpired || isLoading

  return (
    <div className="flex gap-4 mt-auto ml-auto">
      <Button
        type="button"
        variant="ghost"
        size="lg"
        onClick={onCancel}
      >
        Cancel
      </Button>

      <Tooltip
        content={hasSubscriptionExpired ? SUBSCRIPTION_EXPIRED_MESSAGE : undefined}
        disabled={!hasSubscriptionExpired}
      >
        <Button
          isLoading={isLoading}
          type="submit"
          size="lg"
          disabled={isButtonDisabled}
        >
          Save Changes
        </Button>
      </Tooltip>
    </div>
  )
}
